import {
  ActionIcon,
  Card,
  Divider,
  Grid,
  Group,
  Loader,
  Modal,
  Text,
} from "@mantine/core";
import { IconEye } from "@tabler/icons-react";
import { useState } from "react";
import { repositoryPos } from "../../../../_base/_const/_constVar";
import { MessageResponse } from "../../../../model/MessageResponse";
import { NotificationExtension } from "../../../../_base/extension/NotificationExtension";

const CustomerDetail = ({
  customerCheck,
  attribute36,
  orderType,
  taxInfo,
}: {
  customerCheck: any;
  attribute36?: any;
  orderType?: any;
  taxInfo?: any;
}) => {
  const [opened, setOpened] = useState(false);
  const [loading, setLoading] = useState(false);
  const [dataCheckOrder, setDataCheckOrder] = useState<any>();
  const [customerDetail, setCustomerDetail] = useState<any>(null);

  const handleOpenModal = async () => {
    setOpened(true);
    setLoading(true);
    
    try {
      // Call API để lấy chi tiết khách hàng
      const customerDetailResponse = await repositoryPos.get<MessageResponse<any>>(
        `/api/v1/TblDmCustomer/get-detail?id=${customerCheck?.id}`
      );
      
      if (customerDetailResponse && customerDetailResponse.success) {
        setCustomerDetail(customerDetailResponse.data);
      }

      // Call API để kiểm tra đơn hàng
      const orderCheckResponse = await repositoryPos.post<MessageResponse<any>>(
        `/api/v1/TblDmCustomer/check-order-total`,
        {
          customerId: customerCheck?.id,
          type: orderType,
        }
      );
      
      if (orderCheckResponse && orderCheckResponse.success) {
        setDataCheckOrder(orderCheckResponse.data);
      }
    } catch (error) {
      console.error("Error fetching customer details:", error);
      NotificationExtension.Fails("Không thể tải thông tin khách hàng");
    } finally {
      setLoading(false);
    }
  };


  console.log("customerCheck", customerCheck);







  return (
    <>
      <ActionIcon
        onClick={handleOpenModal}
        color="blue"
        variant="light"
        size="lg"
        radius="xl"
        style={{ transition: "transform 0.2s ease", pointerEvents: "auto" }}
      >
        <IconEye size={22} />
      </ActionIcon>

      <Modal
        opened={opened}
        onClose={() => setOpened(false)}
        title="Thông tin khách hàng"
        size="lg"
        centered
      >
        {loading ? (
          <Group justify="center" py="lg">
            <Loader color="blue" />
          </Group>
        ) : customerCheck ? (
          <Card shadow="sm" padding="lg" radius="md" withBorder mt={16}>
            <Grid>
              <Grid.Col span={6}>
                <Text>
                  <strong>Tên:</strong> {customerDetail?.name || customerCheck.name}
                </Text>
              </Grid.Col>
              <Grid.Col span={6}>
                <Text>
                  <strong>Mã số khách hàng:</strong> {customerDetail?.code || customerCheck.code}
                </Text>
              </Grid.Col>
              <Grid.Col span={6}>
                <Text>
                  <strong>Điện thoại:</strong> {customerDetail?.telephoneNumber || customerCheck.telephoneNumber}
                </Text>
              </Grid.Col>
              <Grid.Col span={6}>
                <Text>
                  <strong>Email:</strong> {customerDetail?.email || customerCheck.email || "Không có"}
                </Text>
              </Grid.Col>
              <Grid.Col span={12}>
                <Text>
                  <strong>Địa chỉ giao hàng:</strong>{" "}
                  {customerDetail
                    ? [
                        customerDetail.address,
                        customerDetail.communeName,
                        customerDetail.districtName,
                        customerDetail.provinceName,
                      ]
                        .filter(Boolean)
                        .join(" - ")
                    : customerCheck.address}
                </Text>
              </Grid.Col>
            </Grid>

            <Divider my="md" />

            <Grid>
              <Grid.Col span={6}>
                <Text>
                  <strong>Mã số thuế:</strong> {customerDetail?.taxCode || customerCheck.taxCode}
                </Text>
              </Grid.Col>
              <Grid.Col span={6}>
                <Text>
                  <strong>Công ty:</strong> {customerDetail?.companyName || customerCheck.companyName}
                </Text>
              </Grid.Col>
              <Grid.Col span={6}>
                <Text>
                  <strong>Hạn mức công nợ:</strong> {customerDetail?.debtLimit ?? customerCheck.debtLimit}
                </Text>
              </Grid.Col>
              <Grid.Col span={6}>
                <Text>
                  <strong>Thời hạn công nợ:</strong> {customerDetail?.debtTerm ?? customerCheck.debtTerm}{" "}
                  ngày
                </Text>
              </Grid.Col>

              <Grid.Col span={12}>
                <Text>
                  <strong>Người mua hàng:</strong>
                  {attribute36 ? attribute36 : "Không có"}
                </Text>
              </Grid.Col>
              {taxInfo?.TaxAddress && (
                <Grid.Col span={12}>
                  <Text>
                    <strong>Địa chỉ viết hóa đơn:</strong> {taxInfo.TaxAddress}
                  </Text>
                </Grid.Col>
              )}
            </Grid>
            <Divider my="md" />
            <Grid>
              <Grid.Col span={6}>
                <Text>
                  <strong>Số đơn hàng:</strong>{" "}
                  {dataCheckOrder?.orderCount ?? "Không có"}
                </Text>
              </Grid.Col>
              <Grid.Col span={6}>
                <Text>
                  <strong>Tổng giá trị mua hàng:</strong>{" "}
                  {dataCheckOrder?.totalAmount
                    ? dataCheckOrder?.totalAmount.toLocaleString("vi-VN") + " ₫"
                    : "Không có"}
                </Text>
              </Grid.Col>
            </Grid>
          </Card>
        ) : (
          <Text color="dimmed">Không có dữ liệu khách hàng.</Text>
        )}
      </Modal>
    </>
  );
};

export default CustomerDetail;
